import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function UsersPageFooter({
  count,
  hasMore,
  loading,
  error,
  onLoadMore,
  onRetry,
}) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
        py: 2,
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {t('users_page_count', {
          defaultValue: 'Mostrando {{count}} registros',
          count,
        })}
      </Typography>
      {error ? (
        <Typography variant="body2" color="error">
          {error}{' '}
          <Typography
            component="span"
            sx={{ textDecoration: 'underline', cursor: 'pointer' }}
            onClick={onRetry}
          >
            {t('retry', { defaultValue: 'Reintentar' })}
          </Typography>
        </Typography>
      ) : null}
      {hasMore ? (
        <Button variant="outlined" disabled={loading} onClick={onLoadMore}>
          {loading
            ? t('loading', { defaultValue: 'Cargando...' })
            : t('load_more_users', { defaultValue: 'Cargar más' })}
        </Button>
      ) : null}
    </Box>
  );
}
